import { GiaModel } from "../../../../../../Wrap/Models/Models/QuoteAndApplyBase/InvestmentAccount/GiaModel";
import { PaymentsHelper } from "./PaymentsHelper";
import { TransferHelper } from "./TransferHelper";

export class GiaHelper {
    static hasPaymentsTransfer(model: GiaModel): boolean {
        return (
            PaymentsHelper.hasSinglePayments(model) ||
            PaymentsHelper.hasRegularPayments(model) ||
            this.hasTransfers(model)
        );
    }

    static transfersTotal(model: GiaModel): number {
        const transfers: any = model.GiaTransfers;
        let result = 0;

        if (!transfers || transfers.length === 0) {return result;}

        transfers.forEach((transfer) => {
            result += TransferHelper.getTransferInvestmentTotal(transfer.Instruments, transfer.ReRegisterValue);
        });

        return result;
    }

    static hasTransfers(model: GiaModel): boolean {
        return model.GiaTransfers && model.GiaTransfers.length > 0;
    }
}
